import {BasicReducerState, initialReducerState} from "../BasicReducerState";
import {UserAttendanceTime} from "../../models/timesheet/UserAttendanceTime";
import {Nullable} from "../../models/common/Nullable";
import {
    FETCH_USER_ATTENDANCE_TIME,
    FETCH_USER_ATTENDANCE_TIME_ERROR,
    FETCH_USER_ATTENDANCE_TIME_SUCCESS,
    UPDATE_USER_ATTENDANCE_TIME,
    UPDATE_USER_ATTENDANCE_TIME_ERROR,
    UPDATE_USER_ATTENDANCE_TIME_SUCCESS,
    UserAttendanceTimeViewActionTypes
} from "../../actions/timesheet/UserAttendanceTimeActions";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {MapByStr} from "../../models/common/Map";
import {formatDate} from "../../helpers/DateTimeHelpers";
import {German} from "../../config/languages/German";
import {dateMapKey} from "../../models/calendar/Holiday";


export interface UserAttendanceTimeState extends BasicReducerState< Nullable< UserAttendanceTime[] >, UserAttendanceTime> {
    attendanceByDate: MapByStr<UserAttendanceTime>
}


const userAttendanceTimeInitState: UserAttendanceTimeState =  {
    ...initialReducerState(),
    attendanceByDate: {}
}

export function UserAttendanceTimeReducer(
    state: UserAttendanceTimeState = userAttendanceTimeInitState,
    action: UserAttendanceTimeViewActionTypes
) {

    switch( action.type ) {

        case FETCH_USER_ATTENDANCE_TIME:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: startFetchingRequestState()
                },
            };
        case FETCH_USER_ATTENDANCE_TIME_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    entries: action.payload.entries,
                    request: successFetchingRequestState()
                },
                attendanceByDate: action.payload.entries.reduce(
                    ( _acc, _attendance ) =>  {
                        const startAt = new Date( _attendance.startAt );
                        const finishAt = new Date( _attendance.finishAt );
                        return {
                            ..._acc,
                            [ dateMapKey( startAt ) ]: {
                                ..._attendance,
                                startAt: startAt,
                                finishAt: finishAt
                            }
                        };
                    }, {}
                )
            };
        case FETCH_USER_ATTENDANCE_TIME_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case UPDATE_USER_ATTENDANCE_TIME:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case UPDATE_USER_ATTENDANCE_TIME_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case UPDATE_USER_ATTENDANCE_TIME_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };
        default:
            return state


    }



}